export const stages = [
  {
    id: 'upload',
    title: '\u2460' + ' Upload Image',
    path: '/labs/image-to-3d',
  },
  {
    id: 'progress',
    title: '\u2461' + ' Generating GLB',
    path: '/labs/image-to-3d/progress',
  },
  {
    id: 'download',
    title: '\u2462' + ' Download GLB',
    path: '/labs/image-to-3d/download',
  },
];
